import { type MutableRefObject } from 'react'

import {
  ExpenseLineItemForm,
  type ExpenseLineItemFormHandle,
} from '@webapp/modules/expense/components/ExpenseLineItemForm'
import { type ExpenseFormReimbursementCustomization } from '@webapp/modules/expense/entities/enums'
import { type ExpenseItem } from '@webapp/modules/expense/entities/ExpenseItem'
import { type RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { useEditExpenseLineItemPresenter } from './useEditExpenseLineItemPresenter'

export interface IEditExpenseLineItemPresenterProps {
  item: ExpenseItem
  expenseReportId: number
  requesterId: number
  secondaryCategoryId: number | undefined
  reimbursementSetting: ExpenseFormReimbursementCustomization
  mileageConfiguration?: RequestMileageConfiguration | null
  attachment: string
  onSuccess: () => void
  formRef?: MutableRefObject<ExpenseLineItemFormHandle | null>
  onSubmittingChange?: (isSubmitting: boolean) => void
}

export const EditExpenseLineItemPresenter = ({
  item,
  expenseReportId,
  requesterId,
  secondaryCategoryId,
  reimbursementSetting,
  mileageConfiguration = null,
  attachment,
  onSuccess,
  formRef,
  onSubmittingChange,
}: IEditExpenseLineItemPresenterProps) => {
  const {
    commands: { handleSubmit },
    states: { isSubmitting },
  } = useEditExpenseLineItemPresenter({
    item,
    expenseReportId,
    reimbursementSetting,
    onSuccess,
    onSubmittingChange,
  })

  return (
    <ExpenseLineItemForm
      item={item}
      reimbursementSetting={reimbursementSetting}
      secondaryCategoryId={secondaryCategoryId}
      requesterId={requesterId}
      attachment={attachment}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      formRef={formRef}
      mileageConfiguration={mileageConfiguration}
    />
  )
}
